export default "__VITE_ASSET__CxqXuyKZ__";